// components/AirConfigModal.js
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    MenuItem,
    Grid,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
import { useToast } from "./Toast";
  const AirConfigModal = ({ kiosk, open, onClose }) => {
     const Toast = useToast();
     const kioskId = kiosk._id;
     const token = localStorage.getItem("token");
    const [formValues, setFormValues] = useState({
      
      screen_saver_timeout: '',
      frontColor: "",
      upperColor: "",
      lowerColor: "",
      jawThreshold: '',
      faceThreshold: '',
      actuatorVersion: '',
      servoAngle: '',
      upper_step: '',
      lower_step: '',
      actuator_wait_delay: '',
      auto_capture_time: '',
      consecutive_jaw_threshold: '',
      camera_resolution: '',
      actuator_step_size: '',
      teethVisibilityThreshold: '',
    });
  
    useEffect(() => {
        const ledParts = (kiosk.ledColors || "").split("/");
      setFormValues({
     
        screen_saver_timeout: kiosk.screen_saver_timeout || 300000,
        frontColor: ledParts[0] || "",
        upperColor: ledParts[1] || "",
        lowerColor: ledParts[2] || "",
        jawThreshold: kiosk.jawThreshold,
        faceThreshold: kiosk.faceThreshold,
        actuatorVersion: kiosk.actuatorVersion,
        servoAngle: kiosk.servoAngle,
        upper_step: kiosk.upper_step,
        lower_step: kiosk.lower_step,
        actuator_wait_delay: kiosk.actuator_wait_delay,
        auto_capture_time: kiosk.auto_capture_time,
        consecutive_jaw_threshold: kiosk.consecutive_jaw_threshold,
        camera_resolution: kiosk.camera_resolution,
        actuator_step_size: kiosk.actuator_step_size,
        teethVisibilityThreshold: kiosk.teethVisibilityThreshold,
      });
    }, [kiosk]);
  
    const handleChange = (key, value) => {
      setFormValues((prev) => ({ ...prev, [key]: value }));
    };
  
    const handleSave = async () => {
        const {
          frontColor,
          upperColor,
          lowerColor,
          ...restValues
        } = formValues;
      
        const payload = {
         _id:kioskId,
          ...restValues,
          ledColors: `${frontColor}/${upperColor}/${lowerColor}`,
        };
      
      
        try {
          const res = await fetch(`${process.env.REACT_APP_API_HOST_URL}/ops/v1/kiosks/update`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });
      
          if (!res.ok) throw new Error("Request failed");
      
          Toast.success("Configuration saved!");
          onClose();
        } catch (e) {
          console.error("Error:", e);
          Toast.error("An error occurred while submitting!");
        }
      };
      
  
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Air Config</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} marginY={1}>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Screen Saver Timeout (minutes)"
                fullWidth
                select
                value={formValues.screen_saver_timeout}
                onChange={(e) => handleChange("screen_saver_timeout", parseInt(e.target.value))}
              >
                {[...Array(10)].map((_, i) => {
                  const min = i + 1;
                  return (
                    <MenuItem key={min} value={min * 60000}>
                      {min} minute{min > 1 ? "s" : ""}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
  
            {["frontColor", "upperColor", "lowerColor"].map((key) => (
              <Grid item xs={12} sm={4} key={key}>
                <TextField
                  fullWidth
                  label={key.replace("Color", "").toUpperCase()}
                  placeholder="RGB Code"
                  value={formValues[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                />
              </Grid>
            ))}
  
            {[
              "jawThreshold" ,
              "faceThreshold" ,
              "actuatorVersion" ,
              "servoAngle" ,
              "upper_step" ,
              "lower_step",
              "actuator_wait_delay" ,
              "auto_capture_time",
              "consecutive_jaw_threshold",
              "camera_resolution" ,
              "actuator_step_size" ,
              "teethVisibilityThreshold" ,
            ].map((key) => (
              <Grid item xs={12} sm={4} key={key}>
                <TextField
                  fullWidth
                  type="number"
                  label={key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())}
                  value={formValues[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default AirConfigModal;
  